import { z } from 'zod/v4';
import { procedure } from '@epihub/core/src/procedure';
import { zodConversation } from '../types';
import { zodActionEvent } from '../model/actions';
import { SupportedLanguages } from '../model/const';

export const converseProcedure = procedure({
  path: '/converse' as const,

  params: z.object({}),

  method: 'post' as const,
  query: z.object({}),

  body: zodConversation.extend({
    responseId: z.string(),
    language: z.enum(SupportedLanguages),
  }),

  headers: z.object({}),

  responses: {
    200: zodConversation.extend({
      responseId: z.string(),
      actionEvents: z.array(zodActionEvent),
    }),
  },
});
